/**
 * API Configuration
 * Gestisce la configurazione base per le chiamate API
 */

// Base URL dell'API - caricata da variabile d'ambiente
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000';

// Base URL del servizio di ricerca (search-anutel, porta 8081)
export const SEARCH_API_BASE_URL = process.env.REACT_APP_SEARCH_API_BASE_URL || 'http://localhost:8081';

// Base URL dell'API pubblica di verifica attestati (team FormazioneOnline, servizio terzo
// indipendente) — chiamata diretta dal browser, nessun token/interceptor (vedi verificaAttestatoService.js)
export const FORMAZIONE_ONLINE_API_URL = process.env.REACT_APP_FORMAZIONE_ONLINE_URL || 'https://formazioneonline.anutel.it';

// Endpoint dell'API
export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: '/api/Auth/login',
    REGISTER: '/api/Auth/register',
    VERIFY_OTP: '/api/Auth/verify-otp', // ✅ NUOVO: Verifica codice OTP
    VERIFY: '/api/Auth/verify',
    ME: '/api/Auth/me',
    REFRESH: '/api/Auth/refresh',
    LOGOUT: '/api/Auth/logout',
    PASSWORD: '/api/Auth/password',
    FORGOT_PASSWORD: '/api/Auth/forgot-password',
    VERIFY_RESET_OTP: '/api/Auth/verify-reset-otp',
    RESET_PASSWORD: '/api/Auth/reset-password',
    USER: '/api/Auth/user',
    AVATAR: '/api/Auth/avatar',
    GET_USERS: '/api/Auth/getUsers',
    GET_ROLES: '/api/Auth/getRoles',
    SET_ROLE: '/api/Auth/setRole',
    DELETE_USER: '/api/Auth/admin/users',
    BATCH_DELETE_USERS: '/api/Auth/admin/batch-delete',
    ONLINE_USERS: '/api/Auth/online-users', // ✅ NUOVO: Conteggio utenti online
  },
  PROFILE: {
    ANAGRAFICA: '/api/Profile/anagrafica',
    IMPIEGHI: '/api/Profile/impieghi',
    ANAGRAFICHE_ENTE: '/api/Profile/getAnagrafiche',
    SEND_ANOMALIA: '/api/Profile/sendAnomalia',
    CONTATTI_THUMBNAILS: '/api/Profile/contatti/thumbnails',
    VERIFICA_DUPLICATO: '/api/Profile/verifica-duplicato',
    PRESA_VISIONE_STATUS: '/api/Profile/presa-visione-status',
  },
  LOOKUP: {
    ENTI: '/api/Lookup/enti',
  },
  FORMAZIONE: {
    INIZIATIVE: '/api/Eventi/getIniziative',
    STATS: '/api/Formazione/stats',
    STATS_COLLABORATORI: '/api/Formazione/stats-collaboratori', // + /{idEnte}
    GALLERIA_ANNI:     '/api/GalleriaIncontri/anni',
    GALLERIA_ALBUMS:   '/api/GalleriaIncontri/albums',
    GALLERIA_PHOTOS:   '/api/GalleriaIncontri/photos',
    GALLERIA_PHOTO:    '/api/GalleriaIncontri/photo',
    GALLERIA_DOWNLOAD: '/api/GalleriaIncontri/photo',
  },
  DOCUMENTI: {
    TREE:      '/api/Documenti/tree',
    DIRECTORY: '/api/Documenti/directory',
    CERCA:     '/api/Documenti/cerca',
    RECENTI:   '/api/Documenti/recenti',
    DOWNLOAD:  '/api/Documenti/file',
  },
  DOCUMENTI_PUBBLICI: {
    GET:      '/api/DocumentiPubblici',
    DOWNLOAD: '/api/DocumentiPubblici',
  },
  ARTICOLI: {
    GET_PUBLIC: '/api/Site/get-article-public',
  },
  // Feature "Articoli" di admin-anutel (t_articoli su DB Site, autonoma dalla legacy ARTICOLI sopra)
  PAGINA: {
    GET: '/api/Articoli/public',
  },
  RICERCHE: {
    SEARCH:      '/api/Ricerca/articoli',
    CONTENUTO:   '/api/Ricerca/articoli',
    RECENTI:     '/api/Ricerca/articoli/recenti',
    ESTENDI_WEB: '/api/Ricerca/estendi-web',
    CATEGORIA:   '/api/Ricerca/articoli/categoria',
    PAGINE_CONTENUTO: '/api/Ricerca/pagine',
    ELENCO:        '/api/Ricerca/articoli/elenco',
    ELENCO_EXPORT: '/api/Ricerca/articoli/elenco/export',
  },
  REFERENTE: {
    STATO_ASSOCIATO:       '/api/Referente/stato-associato',
    ASSISTENZA_TASSONOMIA: '/api/Referente/assistenza/tassonomia',
    ASSISTENZA_INVIA:      '/api/Referente/assistenza/invia-quesito',
    ASSISTENZA_STORICO:    '/api/Referente/assistenza/storico',
    ASSISTENZA_CREDITI:    '/api/Referente/assistenza/crediti',
  },
  PERSONALE: {
    STATO_ASSOCIATO: '/api/Personale/stato-associato',
  },
  NOTE: {
    MIE: '/api/Note/mie',
    BASE: '/api/Note', // usato per comporre `${BASE}/${id}/letto`
  },
  CONVENZIONI: {
    GET: '/api/Convenzioni/public',
    SERVIZIO: '/api/Convenzioni/public/servizio',
  },
  // Altri endpoint possono essere aggiunti qui
};

// Timeout per le richieste (in millisecondi)
export const API_TIMEOUT = 30000; // 30 secondi

// Configurazione axios di default
export const API_CONFIG = {
  baseURL: API_BASE_URL,
  timeout: API_TIMEOUT,
  headers: {
    'Content-Type': 'application/json',
  },
};

// Configurazione axios per search-anutel (timeout più alto per embedding Ollama)
export const SEARCH_API_CONFIG = {
  baseURL: SEARCH_API_BASE_URL,
  timeout: 60000,
  headers: {
    'Content-Type': 'application/json',
  },
};
